import { Navigate, Outlet } from "react-router-dom";

import type { UserAccess } from "@/types/users";
import { ROUTES } from "@/constants/routes.constants";
import { useUser } from "@/context/user-provider";

type Props = {
  requires: keyof UserAccess;
};

export const AccessRoute: React.FC<Props> = ({ requires }) => {
  const { access } = useUser();

  if (!access[requires]) {
    return <Navigate to={ROUTES.PROFILE} replace />;
  }

  return <Outlet />;
};
